const icons = {
    image: 'fa fa-file-image',
    pdf: 'fa fa-file-pdf',
    word: 'fa fa-file-word',
    powerpoint: 'fa fa-file-powerpoint',
    excel: 'fa fa-file-excel',
    csv: 'fa fa-file-alt',
    audio: 'fa fa-file-audio',
    video: 'fa fa-file-video',
    archive: 'fa fa-file-archive',
    code: 'fa fa-file-code',
    text: 'fa fa-file-alt',
};

const list = {
    gif: icons.image,
    jpeg: icons.image,
    jpg: icons.image,
    png: icons.image,

    pdf: icons.pdf,

    doc: icons.word,
    docx: icons.word,

    ppt: icons.powerpoint,
    pptx: icons.powerpoint,

    xls: icons.excel,
    xlsx: icons.excel,

    csv: icons.csv,

    aac: icons.audio,
    mp3: icons.audio,
    ogg: icons.audio,

    avi: icons.video,
    flv: icons.video,
    mkv: icons.video,
    mp4: icons.video,

    gz: icons.archive,
    zip: icons.archive,

    css: icons.code,
    html: icons.code,
    js: icons.code,

    txt: icons.text,
};

export default function (ext) {
    if (ext) {
        return list[ext.toLowerCase()];
    }
}
